import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton", "loadingRow", "resultArea", "formArea"]
  static values = { syncId: String }

  activateSubmit(event) {
    const select = event.target
    if (!this.hasSubmitButtonTarget) return
    this.submitButtonTarget.disabled = !select.value
  }

  // Called on form submit event — shows loading state
  submit() {
    if (this.hasFormAreaTarget) this.formAreaTarget.classList.add('d-none')
    if (this.hasLoadingRowTarget) this.loadingRowTarget.classList.remove('d-none')
    if (this.hasResultAreaTarget) this.resultAreaTarget.innerHTML = ''
  }

  // Called on file input change — submits the form and shows loading (Etsy PDF flow)
  submitFile() {
    this.submit()
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
